const data = {
  pageName: "SAMOffer",
  services: {
    translations: {
      url: "SAMOffer/translations",
      params: {}
    },
    createOTP: {
      url: "SAMOffer/createOTP",
      params: {}
    },
    validateOTP: {
      url: "SAMOffer/validateOTP",
      params: {}
    },
    SR: {
      url: "SAMOffer/SR",
      params: {}
    }
  },
  externalLinks: {
    offerPage: ""
  }
};
exports.data = data;
